export default function TrustSection() {
  return (
    <section className="py-16 md:py-24 px-6 md:px-10 bg-background-50">
      <div className="max-w-[1280px] mx-auto">
        <div className="mb-14">
          <p className="font-heading italic text-sm text-foreground-400 mb-2">Data Driven</p>
          <h2 className="font-heading text-3xl md:text-5xl font-bold text-foreground-950 leading-tight">
            Trusted
            <br />
            <span className="italic font-normal text-foreground-700">Spreadsheet</span>
            <br />
            Authority
          </h2>
          <p className="text-foreground-500 text-sm mt-3">Real numbers from real buyers.</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 md:gap-6">
          <div className="rounded-lg p-8 md:p-10 flex flex-col justify-between min-h-[280px] bg-accent-100/70">
            <div>
              <span className="font-heading text-6xl md:text-7xl font-bold text-accent-600">98%</span>
              <p className="text-foreground-700 text-sm md:text-base mt-3 max-w-[300px]">
                Coverage across all major agent platforms. Our database spans the most trusted sources.
              </p>
            </div>
            <div className="flex items-center gap-2 mt-6">
              <span className="font-heading italic text-accent-600 text-sm">Comprehensive coverage</span>
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="w-9 h-9 flex items-center justify-center rounded-full bg-accent-500 text-white hover:bg-accent-600 transition-colors cursor-pointer"
              >
                <i className="ri-arrow-right-up-line text-sm"></i>
              </a>
            </div>
          </div>

          <div className="rounded-lg p-8 md:p-10 flex flex-col justify-between min-h-[280px] bg-primary-100/70">
            <div>
              <span className="font-heading text-6xl md:text-7xl font-bold text-primary-600">60+</span>
              <p className="text-foreground-700 text-sm md:text-base mt-3 max-w-[300px]">
                Curated buying guides and comparison pages updated monthly with the latest product data and verified finds.
              </p>
            </div>
            <div className="flex items-center gap-2 mt-6">
              <span className="font-heading italic text-primary-600 text-sm">Updated every month</span>
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="w-9 h-9 flex items-center justify-center rounded-full bg-primary-500 text-white hover:bg-primary-600 transition-colors cursor-pointer"
              >
                <i className="ri-arrow-right-up-line text-sm"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}